{
  "name": "salmon-elog",
  "version": "2.11",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "test": "ng test",
    "lint": "ng lint",
    "e2e": "ng e2e"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^21.2.5",
    "@angular/cdk": "^21.2.5",
    "@angular/common": "^21.2.5",
    "@angular/compiler": "^21.2.5",
    "@angular/core": "^21.2.5",
    "@angular/forms": "^21.2.5",
    "@angular/material": "^21.2.5",
    "@angular/platform-browser": "^21.2.5",
    "@angular/platform-browser-dynamic": "^21.2.5",
    "@angular/router": "^21.2.5",
    "@angular/service-worker": "^21.2.5",
    "@ng-bootstrap/ng-bootstrap": "^20.0.0",
    "@ng-web-apis/common": "^3.0.6",
    "@ng-web-apis/geolocation": "^3.0.6",
    "@popperjs/core": "^2.11.6",
    "@types/crypto-js": "^4.2.1",
    "@types/pouchdb": "^6.4.2",
    "@types/pouchdb-find": "^7.3.0",
    "bootstrap": "^5.2.3",
    "crypto-js": "^4.2.0",
    "global": "^4.4.0",
    "jszip": "^3.10.1",
    "jwt-decode": "^4.0.0",
    "lodash": "^4.17.21",
    "nanoid": "^5.0.4",
    "ng2-pdf-viewer": "^10.4.0",
    "ngx-online-status": "^2.0.0",
    "ngx-toastr": "^18.0.0",
    "pouchdb": "^9.0.0",
    "pouchdb-find": "^8.0.1",
    "rxjs": "^7.8.0",
    "tslib": "^2.0.0",
    "whirlpool-hash": "^1.1.6",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^21.2.5",
    "@angular/cli": "^21.2.5",
    "@angular/compiler-cli": "^21.2.5",
    "@angular/localize": "^21.2.5",
    "@types/jasmine": "^4.3.1",
    "@types/lodash": "^4.17.20",
    "@types/node": "^22.19.3",
    "jasmine-core": "^5.1.2",
    "jasmine-spec-reporter": "~7.0.0",
    "karma": "~6.4.3",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.1",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "^2.1.0",
    "ts-node": "~8.3.0",
    "tslint": "~6.1.0",
    "typescript": "~5.9.3"
  },
  "overrides": {
    "undici": ">=7.24.0",
    "vite": ">=7.3.2"
  }
}
